import { Injectable } from '@angular/core';
import { Scan } from '@softline/application';
import { Material } from '../types/material';

export interface LighterMaterial {
  cartikelnummer: string;
  bezeichnung: string;
  gewicht: number;
  legierung?: string;
}

@Injectable({ providedIn: 'root' })
export class MaterialService {
  getMaterial(scan: Scan): Promise<Material> {
    return new Promise((resolve) => resolve({} as Material));
  }

  getMaterials(id: number): Promise<Material[]> {
    return new Promise((resolve) => resolve([]));
  }

  getLighterMaterials(idkopfau: number | string, gewicht: number): Promise<LighterMaterial[]> {
    return new Promise((resolve) => resolve([]));
  }
}